import DeleteIcon from "@usas/ui-web/components/icons/DeleteIcon";
import SGColumnHeader from "@usas/ui-web/components/grids/SGColumnHeader";
import EditIcon from "@usas/ui-web/components/icons/EditIcon";

import useSortableGrid from "@usas/ui-web/utils/UseSortableGrid";
import SGConstants from "@usas/ui-web/utils/SGConstants";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LargeGridRow = ({ member, onEditClicked, onDeleteClicked }) => (
  <tr>
    <td>{member.firstName || ''} {member.lastName || ''}</td>
    <td>{member.eventName || ''}</td>
    <td>{member.coachOfRecord || ''}</td>
    <td>{member.groupAttendeeType || ''}</td>
    <td>{member.selectionStatus || ''}</td>
    <td>
      {onEditClicked &&
        <button
          className={global.IconButtonMargin}
          type="button"
          onClick={() => onEditClicked(member)}>
          <EditIcon />
        </button>
      }
      {onDeleteClicked &&
        <button
          className={global.IconButtonMargin}
          type="button"
          onClick={() => onDeleteClicked(member)}>
          <DeleteIcon />
        </button>
      }
    </td>
  </tr>
);

const CampGroupMemberGridLarge = ({ data, isLoading, onEditClicked, onDeleteClicked }) => {
  const {
    sortableGridState,
    onColumnClicked
  } = useSortableGrid(data);

  return (
    <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
      <thead>
        <tr>
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Name'} columnField={'lastName'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Event'} columnField={'eventName'}
            sortType={SGConstants.SORT_TYPE_LENGTH} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Coach of Record'} columnField={'coachOfRecord'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Attendee Type'} columnField={'groupAttendeeType'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Selection Status'} columnField={'selectionStatus'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {isLoading === true
          ? <tr><td colSpan="6">Loading...</td></tr>
          : sortableGridState.sortedGridData.length > 0
            ? sortableGridState.sortedGridData.map((member, i) => <LargeGridRow key={i} member={member} onEditClicked={onEditClicked} onDeleteClicked={onDeleteClicked} />)
            : <tr><td colSpan="6">No Group Members</td></tr>
        }
      </tbody>
    </table>
  );
}

export default CampGroupMemberGridLarge;